import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <div className="navigation-left">
            <a href="/">
              <div aria-label="Ketame Home" className="navigation-logo-link">
                <div className="navigation-logo-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m7 10l-.85 8.507A1.357 1.357 0 0 0 7.5 20h.146a2 2 0 0 0 1.857-1.257l.994-2.486A2 2 0 0 1 12.354 15h1.292a2 2 0 0 1 1.857 1.257l.994 2.486A2 2 0 0 0 18.354 20h.146a1.37 1.37 0 0 0 1.364-1.494L19 9h-8c0-3-3-5-6-5l-3 6l2 2zm15 4v-2a3 3 0 0 0-3-3"
                    ></path>
                  </svg>
                </div>
                <span className="section-title">Ketame</span>
              </div>
            </a>
          </div>
          <div className="navigation-center">
            <ul className="navigation-links">
              <li className="navigation-item">
                <a href="/">
                  <div className="navigation-link">
                    <span>Episodes</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="/archive">
                  <div className="navigation-link">
                    <span>Archive</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="/series">
                  <div className="navigation-link">
                    <span>Series</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="/characters">
                  <div className="navigation-link">
                    <span>Characters</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div className="navigation-right">
            <div className="navigation-actions">
              <button
                aria-label="Search comics"
                className="navigation-search-btn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle cx="11" cy="11" r="8"></circle>
                  </g>
                </svg>
              </button>
              <a href="/subscribe">
                <div className="btn btn-primary btn-sm">
                  <span>Subscribe</span>
                </div>
              </a>
            </div>
            <button
              id="navToggle"
              aria-expanded="false"
              aria-controls="mobileMenu"
              aria-label="Toggle menu"
              className="navigation-mobile-toggle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="icon-menu"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 8h16M4 16h16"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>
      <div id="mobileMenu" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <a href="/">
            <div className="navigation-logo-link">
              <div className="navigation-logo-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m7 10l-.85 8.507A1.357 1.357 0 0 0 7.5 20h.146a2 2 0 0 0 1.857-1.257l.994-2.486A2 2 0 0 1 12.354 15h1.292a2 2 0 0 1 1.857 1.257l.994 2.486A2 2 0 0 0 18.354 20h.146a1.37 1.37 0 0 0 1.364-1.494L19 9h-8c0-3-3-5-6-5l-3 6l2 2zm15 4v-2a3 3 0 0 0-3-3"
                  ></path>
                </svg>
              </div>
              <span className="section-title">Ketame</span>
            </div>
          </a>
          <button
            id="navClose"
            aria-label="Close menu"
            className="navigation-mobile-close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                <path d="M3 9h18M9 16l3-3l3 3"></path>
              </g>
            </svg>
          </button>
        </div>
        <div className="navigation-mobile-body">
          <ul className="navigation-mobile-links">
            <li className="navigation-mobile-item">
              <a href="/">
                <div className="navigation-mobile-link">
                  <span>Latest Episodes</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/archive">
                <div className="navigation-mobile-link">
                  <span>Comic Archive</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/series">
                <div className="navigation-mobile-link">
                  <span>Series &amp; Tags</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/characters">
                <div className="navigation-mobile-link">
                  <span>Meet the Cast</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="/about">
                <div className="navigation-mobile-link">
                  <span>The Universe</span>
                </div>
              </a>
            </li>
          </ul>
          <div className="navigation-mobile-footer">
            <a href="/subscribe">
              <div className="btn btn-primary btn-lg">
                <span>Join the Herd</span>
              </div>
            </a>
            <p className="section-content">
              Absurd horse comics for the internet age.
            </p>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay {
  transition: none;
}
.navigation-logo-link:hover, .navigation-mobile-link:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById('navToggle');
  const navClose = document.getElementById('navClose');
  const mobileMenu = document.getElementById('mobileMenu');
  const body = document.body;

  const openMenu = () => {
    mobileMenu.classList.add('is-open');
    navToggle.setAttribute('aria-expanded', 'true');
    body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    mobileMenu.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    body.style.overflow = '';
  };

  navToggle.addEventListener('click', openMenu);
  navClose.addEventListener('click', closeMenu);

  // Close menu when clicking a link
  const mobileLinks = mobileMenu.querySelectorAll('.navigation-mobile-link');
  mobileLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Handle escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Simple scroll hide/show logic for desktop/mobile
  let lastScroll = 0;
  const navWrapper = document.querySelector('.navigation-wrapper');

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll <= 0) {
      navWrapper.style.transform = 'translateY(0)';
      return;
    }
    
    if (currentScroll > lastScroll && !mobileMenu.classList.contains('is-open')) {
      // Scrolling down
      navWrapper.style.transform = 'translateY(-100%)';
    } else {
      // Scrolling up
      navWrapper.style.transform = 'translateY(0)';
    }
    lastScroll = currentScroll;
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
